export default "__VITE_ASSET__DTsI73_J__"